import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { totalPrice } from "../../utils";
import {
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
} from "../../store/actions/action";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";

const CartPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  const { t } = useTranslation();

  const { carts } = props;

  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t(`cart`)} pagesub={t(`cart`)} />
      <div className="cart-area section-padding">
        <div className="container">
          <div className="form">
            <div className="cart-wrapper">
              <div className="row">
                <div className="col-12">
                  <form action="cart">
                    <table className="table-responsive cart-wrap">
                      <thead>
                        <tr className="main-title">
                          <th className="images images-b">
                            {t(`image`)}
                          </th>
                          <th className="product-2">
                            {t(`productName`)}
                          </th>
                          <th className="pr">{t(`quantity`)}</th>
                          <th className="ptice">{t(`price`)}</th>
                          <th className="stock">{t(`totalPrice`)}</th>
                          <th className="remove remove-b">
                            {t(`action`)}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {carts &&
                          carts.length > 0 &&
                          carts.map((catItem, crt) => (
                            <tr key={crt}>
                              <td className="images">
                                <img src={catItem.proImg} alt="" />
                              </td>
                              <td className="product">
                                <ul>
                                  <li className="first-cart title">
                                    {catItem.title}
                                  </li>
                                  <li>
                                    {t(`category`)} : {catItem.brand}
                                  </li>
                                  <li>
                                    {t(`description`)} :{" "}
                                    {catItem.size.length > 100
                                      ? catItem.size.slice(0, 100) + "..."
                                      : catItem.size}
                                  </li>
                                </ul>
                              </td>
                              <td className="stock">
                                <div className="pro-single-btn">
                                  <Grid className="quantity cart-plus-minus">
                                    <Button
                                      className="dec qtybutton"
                                      onClick={() =>
                                        props.decrementQuantity(catItem.id)
                                      }
                                    >
                                      -
                                    </Button>
                                    <input value={catItem.qty} type="text" />
                                    <Button
                                      className="inc qtybutton"
                                      onClick={() =>
                                        props.incrementQuantity(catItem.id)
                                      }
                                    >
                                      +
                                    </Button>
                                  </Grid>
                                </div>
                              </td>
                              <td className="ptice">
                                {catItem.qty * catItem.price}{" "} {t('currency')}
                              </td>
                              <td className="stock">
                                {catItem.qty * catItem.price}{" "} {t('currency')}
                              </td>
                              <td className="action">
                                <ul>
                                  <li
                                    className="w-btn"
                                    onClick={() =>
                                      props.removeFromCart(catItem.id, t)
                                    }
                                  >
                                    <i className="fi ti-trash"></i>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </form>
                  <div className="submit-btn-area main-title">
                    <ul>
                      <li>
                        <Link
                          onClick={ClickHandler}
                          className="theme-btn"
                          to="/shop"
                        >
                          {t(`continueShopping`)}{" "}
                        </Link>
                      </li>
                      <li>
                        <button type="submit">{t(`updateCart`)}</button>
                      </li>
                    </ul>
                  </div>
                  <div className="cart-product-list main-title">
                    <ul>
                      <li>
                        {t(`totalProduct`)}
                        <span>( {carts.length} )</span>
                      </li>
                      <li>
                        {t(`subPrice`)}
                        <span>{totalPrice(carts)}{" "} {t('currency')}</span>
                      </li>

                      <li className="cart-b">
                        {t(`totalPrice`)}
                        <span>{totalPrice(carts)}{" "} {t('currency')}</span>
                      </li>
                    </ul>
                  </div>
                  <div className="submit-btn-area">
                    <ul>
                      <li className="title">
                        <Link
                          onClick={ClickHandler}
                          className="theme-btn"
                          to="/checkout"
                        >
                          {t(`proceedToCheckout`)}{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};
export default connect(mapStateToProps, {
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
})(CartPage);
